import { GeneralAuthType } from "../../../utils/Entities";
import { AuthType } from "../../../../../models/Entities";
import { authTypeMapping } from "../../../utils/helpers";
import MultiSelectHeader from "../../../shared/MultiSelectHeader";
import useIntegrationBuilderContext from "../../../context/useIntegrationBuilderContext";

interface ConfigurationTypeButtonProps {
  generalAuthConfigType: string | undefined;
  setGeneralAuthConfigType: React.Dispatch<React.SetStateAction<GeneralAuthType | undefined>>;
  setActualAuthType: React.Dispatch<React.SetStateAction<AuthType | undefined>>;
}

const ConfigurationTypeButtons = ({
  generalAuthConfigType,
  setGeneralAuthConfigType,
  setActualAuthType,
}: ConfigurationTypeButtonProps) => {
  const handleButtonClick = (value: GeneralAuthType) => {
    setGeneralAuthConfigType(value);
    setActualAuthType(authTypeMapping[value]);
  };

  const { integration } = useIntegrationBuilderContext();

  const options = [
    {
      value: GeneralAuthType.API,
      text: "API",
      disabled: false,
      selected: generalAuthConfigType === GeneralAuthType.API,
      onClick: handleButtonClick,
    },
    {
      value: GeneralAuthType.SCRAPER,
      text: "Scraper",
      disabled: false,
      selected: generalAuthConfigType === GeneralAuthType.SCRAPER,
      onClick: handleButtonClick,
    },
    {
      value: GeneralAuthType.SFTP,
      text: "SFTP",
      disabled: false,
      selected: generalAuthConfigType === GeneralAuthType.SFTP,
      onClick: handleButtonClick,
    },
    ...(integration?.id === "4f340c8e-10d1-4989-8c36-579c6e0f0b3c"
      ? [
          {
            value: GeneralAuthType.WEB_CONNECTOR,
            text: "Web connector",
            disabled: false,
            selected: generalAuthConfigType === GeneralAuthType.WEB_CONNECTOR,
            onClick: handleButtonClick,
          },
        ]
      : []),
  ];
  return (
    <MultiSelectHeader
      dataTestID="field-auth-config-integration-type"
      title="Integration type"
      subtitle="Select what type of integration configuration you'd like to create"
      options={options}
      required
      className="mt-6"
    />
  );
};

export default ConfigurationTypeButtons;
